module.exports = __webpack_public_path__ + "img/2456775.png";